import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15.669v-3.336C4 6.074 9.074 1 15.333 1h1.334C22.926 1 28 6.074 28 12.333v8.665a2.671 2.671 0 0 1-2.028 2.592 5.998 5.998 0 0 1-5.97 5.41h-1.45a2.002 2.002 0 0 1-1.884 1.333h-1.336a2 2 0 0 1 0-4h1.336c.872 0 1.612.555 1.886 1.334h1.448a4.665 4.665 0 0 0 4.63-4.094 2.668 2.668 0 0 1-1.965-2.575v-5.33a2.67 2.67 0 0 1 4-2.311v-1.024c0-5.523-4.478-10-10-10h-1.334c-5.523 0-10 4.477-10 10v1.025a2.667 2.667 0 0 1 4 2.311v5.329a2.667 2.667 0 1 1-5.333 0v-5.329Zm13.333 12.66a.663.663 0 0 0-.665-.662h-1.336a.668.668 0 0 0 0 1.333h1.336a.667.667 0 0 0 .665-.665v-.005Zm-12-9.278v-3.382a1.334 1.334 0 1 1 2.667 0v5.329a1.333 1.333 0 1 1-2.667 0V19.05ZM24 15.669v5.329a1.333 1.333 0 1 0 2.667 0v-5.33a1.333 1.333 0 1 0-2.667 0Z",
    fill: "currentColor"
  }));
};

var SvgHeadset = styled(SvgComponent).withConfig({
  displayName: "Headset__SvgHeadset",
  componentId: "sc-1j4trcj-0"
})(["", " ", ""], size, color);
export default SvgHeadset;